/* eslint-disable react-hooks/exhaustive-deps */
import { StockOpnameApi } from "api"
import { useEffect, useState } from "react"
import { Alert } from "react-bootstrap"

export const AlertAlreadyStockOpname = ({ tanggal }) => {
  const {isOpname} = useCheckStockOpname({tanggal})

  return (
    <div>
      <Alert
        variant="danger"
        show={isOpname}
        className="text-center font-weight-bold"
      >
        !Peringatan!
        <br />
        Sudah ada transaksi stock opname pada bulan dan tahun yang sudah
        dipilih, karena akan memengaruhi stok setelah stock opname
      </Alert>
    </div>
  );
};

export const useCheckStockOpname = ({tanggal}) => {
  const [isOpname, setIsOpname] = useState(false);

  const checkStockOpname = ({tanggal}) => {
    StockOpnameApi.alreadyStockOpname({ tanggal }).then(({ data }) => {
      setIsOpname(data?.status);
    });
  };

  useEffect(() => {
    checkStockOpname({tanggal});
  }, [tanggal]);

  return {isOpname}
}